export default __webpack_public_path__ + "static/media/rd.a39c6a7c.png";